import React from "react";

const ButtonLabel = (props) => <span className='d-none d-md-inline' {...props}/>

export default ButtonLabel;